import VendorsIcon from "assets/Home/Vendors.svg";
import BuildingIcon from "assets/Home/Building.svg";
import HomeOwnersIcon from "assets/Home/HomeOwners.svg";
import PropertyOwnerIcon from "assets/Home/PropertyOwner.svg";
import VendorsChooseIcon from "assets/Home/VendorsChoose.svg";
export const faqs = [
  {
    question: "How much does it cost to use Properteasy?",
    answer: `Joining Properteasy is completely free for landlords, homeowners and vendors. There are no 
subscription fees, membership fees, or hidden charges. Property owners pay one, all inclusive 
price for services rendered, and it costs nothing for vendors to join the Properteasy network of 
licensed professionals.`,
  },
  {
    question: "How does Properteasy ensure quality contractors?",
    answer: `Properteasy has rigorous standards in place that all vendors must meet before joining our 
network of trusted professionals. All members must be licensed and insured. Additionally, our 
Quality Control Team conducts field interviews with each and every vendor to determine 
reliability, professionalism and level of expertise before admission to the network is granted. 
Keep in mind, Properteasy was created by seasoned property owners and managers, so we 
know what to look for in a trade professional.`,
  },
  {
    question: "How does Properteasy ensure fair pricing?",
    answer: `The Properteasy system works because it is beneficial to all parties involved. Vendors in the 
Properteasy network benefit from a steady stream of work, which affords us the ability to obtain 
preferential pricing. As a result, property owners benefit from our ability to dispatch one of our 
vetted professionals in virtually any trade category swiftly and efficiently, at reasonable prices. 
Our goal is to provide superior service at fair market prices. 
 
Before admitting vendors to the Properteasy network, we ensure that their pricing is aligned with 
local market rates. Shopping for quotes is a thing of the past with Properteasy. You can rest 
assured that all Properteasy professionals will provide quality service at reasonable prices. 
 
Simply put, everyone wins!`,
  },
  {
    question: "How quickly will my job be done?",
    answer: `During normal business hours, property owners can expect same day job acceptance by a 
licensed professional, usually within a few hours, with emergency service calls being prioritized. 
Our vast network of trusted vendors gives us the bandwidth to respond to your service needs 
swiftly and efficiently. While we move quickly, scheduling is ultimately based upon your 
availability. Our intuitive scheduling interface seamlessly allows you and the vendor to arrange a 
convenient time to meet your maintenance needs.`,
  },
  {
    question: "Is insurance coverage included?",
    answer: `All vendors in the Properteasy network are licensed and insured. Properteasy does not directly 
provide insurance coverage, however, we verify that every vendor we partner with has an active 
and current insurance policy in place to protect both property owners and tenants.`,
  },
  {
    question: "Is all work guaranteed?",
    answer: `Yes. Properteasy stands behind the quality of work completed through our platform. If you're not 
satisfied with the results, report the issue and we'll coordinate a resolution.`,
  },
  {
    question: "What happens if a vendor doesn't show up?",
    answer: `In the rare event a vendor misses a scheduled appointment without notice or communication, we will promptly 
reassign the job to an alternate qualified vendor and prioritize your request to avoid further 
delays. Once you book a maintenance appointment with Properteasy, you can rest assured the 
job will get done.`,
  },
];

export const testimonials = [
  {
    title: "Outstanding choice!",
    description:
      "Properteasy has revolutionized how we handle maintenance across our 50+ properties. The quality of contractors and speed of service is exceptional.",
  },
  {
    title: "Strongly endorsed!",
    description:
      "Since joining Properteasy, my business has grown 40%. The jobs are quality and the payment system gives me confidence.",
  },
  {
    title: "Exceptional Service",
    description:
      "As a first-time landlord, Properteasy made property maintenance stress-free. I found a reliable handyman who now handles all my properties.",
  },
];
export const cardData = [
  {
    title: "For Landlords",
    description:
      "Easily post jobs, choose the right contractors, and manage repairs without the headaches.",
    buttonLabel: "I am a Landlord",
    icon: BuildingIcon,
    items: [
      "Browse and assign trusted pros",
      "Set job preferences and timelines",
      "Get updates and invoices in one place",
    ],
  },
  {
    title: "For Homeowners",
    description:
      "Request home repairs quickly and get matched with the right contractor—no calls or chasing.",
    buttonLabel: "I am a Homeowner",
    icon: HomeOwnersIcon,
    items: [
      "Fast job posting for any repair",
      "Reliable, vetted professionals",
      "Transparent pricing and updates",
    ],
  },
  {
    title: "For Vendors",
    description:
      "Get steady work from real property owners—on your schedule, without lead fees.",
    buttonLabel: "I am a Vendor",
    icon: VendorsIcon,
    items: [
      "Qualified jobs delivered to you",
      "Set your own availability",
      "Instant payments, no subscriptions",
    ],
  },
];
export const data = {
  owners: {
    title: "For Property Owners",
    icon: PropertyOwnerIcon,
    features: [
      {
        title: "Vetted Professionals",
        desc: "All contractors are background-checked & insurance-verified for your peace of mind.",
      },
      {
        title: "Fast Response Times",
        desc: "Get quotes within hours and emergency repairs scheduled within 24 hours.",
      },
      {
        title: "Transparent Pricing",
        desc: "Compare competitive quotes with no hidden fees. Pay only when satisfied.",
      },
    ],
    footer: {
      heading: "Property Management Made Simple",
      desc: "Whether you're managing a single rental or a portfolio of properties, Proptereasy streamlines maintenance coordination and keeps your properties in top condition.",
      button: "Join as a Property owner",
    },
  },
  vendors: {
    title: "For Vendors",
    icon: VendorsChooseIcon,
    features: [
      {
        title: "Quality Leads",
        desc: "Access pre-qualified property owners actively seeking maintenance services.",
      },
      {
        title: "Flexible Work",
        desc: "Choose jobs that fit your schedule, skills, and service area preferences.",
      },
      {
        title: "Grow Your Business",
        desc: "Build your reputation with reviews and expand your client base sustainably.",
      },
    ],
    footer: {
      heading: "Join Our Professional Network",
      desc: "Connect with property owners who value quality work. Build long-term relationships and grow your business with steady, reliable income opportunities.",
      button: "Join as a Vendor",
    },
  },
};
